import util from '@/utils'

/**
 * #=格式化日期
 * @param {String} date     日期对象或字符串
 * @param {String} format   格式化字符串yy-MM-dd
 * @returns {String}
 */
export function dateFormat (date, format = 'yyyy-MM-dd') {
  return util.dateFormat(date, format)
}

/**
 * #=上传文件的下载地址
 * @param {String} url     日期对象或字符串
 * @returns {String}
 */
export function fileFullUrl (url, getTime) {
  return util.getFileFullUrl(url) + (getTime ? `?${new Date().getTime()}` : '')
}
